import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
/**
 * @class away.events.CameraEvent
 */
var CameraEvent = /** @class */ (function (_super) {
    __extends(CameraEvent, _super);
    function CameraEvent(type, camera) {
        var _this = _super.call(this, type) || this;
        _this._camera = camera;
        return _this;
    }
    Object.defineProperty(CameraEvent.prototype, "camera", {
        get: function () {
            return this._camera;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    CameraEvent.prototype.clone = function () {
        return new CameraEvent(this.type, this._camera);
    };
    CameraEvent.PROJECTION_CHANGED = 'projectionChanged';
    return CameraEvent;
}(EventBase));
export { CameraEvent };
